import styled from 'styled-components';
import { ReactSVG } from 'react-svg';
import deliveredIconSVG from 'icons/delivered.svg';
import rejectedIconSVG from 'icons/rejected.svg';

export const CheckmarkIcon = styled(ReactSVG).attrs((props) => {
  return {
    src: deliveredIconSVG,
    'aria-hidden': true,
    ...props,
  };
})`
  circle {
    fill: ${({ theme }) => theme.configs.CTAButton.bgColor};
  }

  path {
    stroke: ${({ theme }) => theme.configs.CTAButton.fontColor};
  }
`;

export const CrossIcon = styled(ReactSVG).attrs((props) => {
  return {
    src: rejectedIconSVG,
    'aria-hidden': true,
    ...props,
  };
})`
  rect {
    fill: ${({ theme }) => theme.configs.CTAButton.bgColor};
  }

  path {
    fill: ${({ theme }) => theme.configs.CTAButton.fontColor};
  }
}
`;

export const CustomProgressIndicatorIcon = styled(ReactSVG)<{
  bgColor: string;
  color: string;
}>`
  svg,
  img {
    width: 39px;
    height: 39px;
  }

  ellipse {
    fill: ${({ bgColor }) => bgColor};
  }

  circle {
    fill: ${({ bgColor }) => bgColor};
  }

  g {
    g {
      stroke: ${({ color }) => color};
    }

    polygon {
      stroke: ${({ color }) => color};
    }

    line {
      stroke: ${({ color }) => color};
    }

    path {
      stroke: ${({ color }) => color};
    }
  }

  g g * {
    stroke: ${({ color }) => color};
  }

  path {
    stroke: ${({ color }) => color};
  }
`;
